const ICON_BASE_URL = "https://q2pay.in/new_assets";

const ICONS = {

    // SETTINGS
    TOTP: `${ICON_BASE_URL}/common/settings/totp.svg`,
    BYOK: `${ICON_BASE_URL}/common/settings/byok.svg`,
    USER: `${ICON_BASE_URL}/common/settings/user.svg`,
    USER_IN_CIRCLE: `${ICON_BASE_URL}/common/dashboard/user_in_circle.svg`,
    IFSC: `${ICON_BASE_URL}/common/settings/ifsc.svg`,
    USERS: `${ICON_BASE_URL}/common/settings/users.svg`,
    LOGOUT: `${ICON_BASE_URL}/common/settings/logout.svg`,
    INVOICES: `${ICON_BASE_URL}/common/settings/invoices.svg`,
    LASTPASS: `${ICON_BASE_URL}/common/settings/lastpass.svg`,
    SERVICES: `${ICON_BASE_URL}/common/settings/services.svg`,
    APP_LOCK: `${ICON_BASE_URL}/common/settings/app_lock.svg`,
    FEATURES: `${ICON_BASE_URL}/common/settings/features.svg`,
    STATISTICS: `${ICON_BASE_URL}/common/settings/statistics.svg`,
    APP_UNLOCK: `${ICON_BASE_URL}/common/settings/app_unlock.svg`,
    PLUS_WHITE: `${ICON_BASE_URL}/common/settings/plus_white.svg`,
    SWAP_ENTITY:`${ICON_BASE_URL}/common/settings/swap_entity.svg`,
    MINUS_WHITE:`${ICON_BASE_URL}/common/settings/minus_white.svg`,
    TEST_MATRIX: `${ICON_BASE_URL}/common/settings/test_matrix.svg`,
    LOGOUT_WHITE: `${ICON_BASE_URL}/common/settings/logout_white.svg`,
    LOGOUT_IN_WHITE_CIRCLE: `${ICON_BASE_URL}/common/settings/logout_in_circle.svg`,
    DIVIDE_WHITE: `${ICON_BASE_URL}/common/settings/divide_white.svg`,
    ENTITY_WHITE: `${ICON_BASE_URL}/common/settings/entity_white.svg`,
    GENERATE_TOKEN: `${ICON_BASE_URL}/common/settings/generate_token.svg`,
    ENTITIES_WHITE: `${ICON_BASE_URL}/common/settings/entities_white.svg`,
    SETTINGS_WHITE: `${ICON_BASE_URL}/common/settings/settings_white.svg`,
    SETTINGS_IN_CIRCLE: `${ICON_BASE_URL}/common/settings/setting_in_circle.svg`,
    CATEGORY_SETUP: `${ICON_BASE_URL}/common/settings/category_setup.svg`,
    SECURITY_CENTER: `${ICON_BASE_URL}/common/settings/security_center.svg`,
    APPLE_PASSWORDS: `${ICON_BASE_URL}/common/settings/apple_passwords.svg`,
    CHANGE_PASSWORD: `${ICON_BASE_URL}/common/settings/change_password.svg`,
    ADD_BUTTON_WHITE: `${ICON_BASE_URL}/common/settings/add_button_white.svg`,
    PAN_VERIFICATION: `${ICON_BASE_URL}/common/settings/pan_verification.svg`,
    GST_VERIFICATION: `${ICON_BASE_URL}/common/settings/gst_verification.svg`,
    CIN_VERIFICATION: `${ICON_BASE_URL}/common/settings/cin_verification.svg`,
    DIN_VERIFICATION: `${ICON_BASE_URL}/common/settings/din_verification.svg`,
    DEVICES: `${ICON_BASE_URL}/common/settings/devices_with_white_circle.svg`,
    IFSC_VERIFICATION: `${ICON_BASE_URL}/common/settings/ifsc_verification.svg`,
    GOOGLE_AUTHENTICATOR: `${ICON_BASE_URL}/common/settings/google_authenticator.svg`,
    EQUAL_WITH_ROUNDNESS: `${ICON_BASE_URL}/common/settings/equals_with_roundness.svg`,
    AUTO_GENERATE_PASSWORD: `${ICON_BASE_URL}/common/settings/auto_generate_password.svg`,
    ROLES_WITHOUT_CIRCLE: `${ICON_BASE_URL}/common/settings/edit_roles_without_circle.svg`,
    ERROR_WITH_WHITE_CIRCLE: `${ICON_BASE_URL}/common/settings/error_with_white_circle.svg`,
    MICROSOFT_AUTHENTICATOR: `${ICON_BASE_URL}/common/settings/microsoft_authenticator.svg`,
    PROFILE_WITH_BLUE_CIRCLE: `${ICON_BASE_URL}/common/settings/profile_with_blue_circle.svg`,
    SWAP_ENTITY_WHITE_CIRCLE: `${ICON_BASE_URL}/common/settings/swap_entity_white_circle.svg`,
    PASSWORD_HIDDEN_LIGHTGREY: `${ICON_BASE_URL}/common/settings/password_hidden_lightgrey.svg`,
    SUBTRACTION_WITH_ROUNDNESS: `${ICON_BASE_URL}/common/settings/subtraction_with_roundness.svg`,
    ENTITIES_WITH_WHITE_CIRCLE: `${ICON_BASE_URL}/common/settings/entities_with_white_circle.svg`,
    PASSWORD_VISIBLE_LIGHTGREY: `${ICON_BASE_URL}/common/settings/password_visible_lightgrey.svg`,
    PROFILE_ICON_OF_NAVIGATIONBAR: `${ICON_BASE_URL}/common/settings/profile_icon_of_navigationbar.svg`,
    CHANGE_PASSWORD_WITH_WHITE_CIRCLE: `${ICON_BASE_URL}/common/settings/change_password_with_white_circle.svg`,
    AUTHORIZED_DEVICES_WITH_WHITE_CICLE: `${ICON_BASE_URL}/common/settings/authorized_devices_with_white_circle.svg`,


    // ARROWS
    ARROW_UP_WHITE: `${ICON_BASE_URL}/common/arrows/arrow_up_white.svg`,
    ARROW_UP_GREEN: `${ICON_BASE_URL}/common/arrows/arrow_up_green.svg`,
    ARROW_DOWN_RED: `${ICON_BASE_URL}/common/arrows/arrow_down_red.svg`,
    ARROW_DOWN_GREY: `${ICON_BASE_URL}/common/arrows/arrow_down_blue.svg`,
    ARROW_RIGHT_GREY: `${ICON_BASE_URL}/common/arrows/arrow_right_grey.svg`,
    ARROW_DOWN_WHITE: `${ICON_BASE_URL}/common/arrows/arrow_down_white.svg`,
    ARROW_LEFT_WHITE: `${ICON_BASE_URL}/common/arrows/arrow_left_white.svg`,
    ARROW_RIGHT_WHITE: `${ICON_BASE_URL}/common/arrows/arrow_right_white.svg`,
    ARROW_RIGHT_ORANGE: `${ICON_BASE_URL}/common/arrows/arrow_right_orange.svg`,
    ARROW_UP_BLUE_WHITE: `${ICON_BASE_URL}/common/arrows/arrow_up_blue_white.svg`,
    ARROW_UP_WHITE_CIRCLE: `${ICON_BASE_URL}/common/arrows/arrow_up_white_circle.svg`,
    ARROW_DOWN_BLUE_WHITE: `${ICON_BASE_URL}/common/arrows/arrow_down_blue_white.svg`,
    ARROW_LEFT_BLUE_WHITE: `${ICON_BASE_URL}/common/arrows/arrow_left_blue_white.svg`,
    ARROW_DOWN_WHITE_LONG: `${ICON_BASE_URL}/common/arrows/arrow_down_white_long.svg`,
    ARROW_RIGHT_GREEN_LONG: `${ICON_BASE_URL}/common/arrows/arrow_right_green_long.svg`,
    ARROW_RIGHT_BLUE_WHITE: `${ICON_BASE_URL}/common/arrows/arrow_right_blue_white.svg`,
    ARROW_DOWN_WHITE_CIRCLE: `${ICON_BASE_URL}/common/arrows/arrow_down_white_circle.svg`,
    ARROW_LEFT_WHITE_CIRCLE: `${ICON_BASE_URL}/common/arrows/arrow_left_white_circle.svg`,
    ARROW_RIGHT_WHITE_CIRCLE: `${ICON_BASE_URL}/common/arrows/arrow_right_white_circle.svg`,
    ARROW_DOWN_DARK_BLUE_BOX: `${ICON_BASE_URL}/common/arrows/arrow_down_dark_blue_box.svg`,
    ARROW_LEFT_DARK_BLUE_BOX: `${ICON_BASE_URL}/common/arrows/arrow_left_dark_blue_box.svg`,
    ARROW_UP_DARK_BLUE_BOX: `${ICON_BASE_URL}/common/arrows/arrow_down_dark_blue_box_ up.svg`,
    ARROW_RIGHT_DARK_BLUE_BOX: `${ICON_BASE_URL}/common/arrows/arrow_right_dark_blue_box.svg`,
    ARROW_RIGHT_ORANGE_CIRCLE: `${ICON_BASE_URL}/common/arrows/arrow_right_orange_circle.svg`,
    BLUE_ARROW_UP_WHITE_CIRCLE: `${ICON_BASE_URL}/common/arrows/blue_arrow_up_white_circle.svg`,
    BLUE_ARROW_DOWN_WHITE_CIRCLE: `${ICON_BASE_URL}/common/arrows/blue_arrow_down_white_circle.svg`,
    BLUE_ARROW_LEFT_WHITE_CIRCLE: `${ICON_BASE_URL}/common/arrows/blue_arrow_left_white_circle.svg`,
    BLUE_ARROW_RIGHT_WHITE_CIRCLE: `${ICON_BASE_URL}/common/arrows/blue_arrow_right_white_circle.svg`,

    // CREATE_FLOW
    AII: `${ICON_BASE_URL}/common/create_flow/aii.svg`,
    EDIT: `${ICON_BASE_URL}/common/create_flow/edit.svg`,
    COPY: `${ICON_BASE_URL}/common/create_flow/copy.svg`,
    CLOSE: `${ICON_BASE_URL}/common/create_flow/close.svg`,
    QR_CODE: `${ICON_BASE_URL}/common/create_flow/qr_code.svg`,
    PROFILE: `${ICON_BASE_URL}/common/create_flow/profile.svg`,
    FAILED_SVG: `${ICON_BASE_URL}/common/create_flow/failed.svg`,
    SUCCESS_SVG: `${ICON_BASE_URL}/common/create_flow/success.svg`,
    PENDING_SVG: `${ICON_BASE_URL}/common/create_flow/pending.svg`,
    OCCURENCES: `${ICON_BASE_URL}/common/create_flow/occurences.svg`,
    BROWSE_FILE: `${ICON_BASE_URL}/common/create_flow/browse_file.svg`,
    INFO_FILLED: `${ICON_BASE_URL}/common/create_flow/info_filled.svg`,
    PASTE_WHITE: `${ICON_BASE_URL}/common/create_flow/paste_white.svg`,
    VIEW_DETAILS: `${ICON_BASE_URL}/common/create_flow/view_details.svg`,
    COPY_BLUE_BG: `${ICON_BASE_URL}/common/create_flow/copy_blue_bg.svg`,
    CONTACT_NO: `${ICON_BASE_URL}/common/create_flow/contact_number.svg`,
    TIMELINE_DOT: `${ICON_BASE_URL}/common/create_flow/timeline_dot.svg`,
    GO_TO_APPROVAL: `${ICON_BASE_URL}/common/view_all/go_to_approval.svg`,
    FILE_ATTACHED: `${ICON_BASE_URL}/common/create_flow/file_attached.svg`,
    SELECT_ACCOUNT: `${ICON_BASE_URL}/common/create_flow/select_account.svg`,
    AUTOFILL_WHITE: `${ICON_BASE_URL}/common/create_flow/autofill_white.svg`,
    DRAG_INDICATOR: `${ICON_BASE_URL}/common/create_flow/drag_indicator.svg`,
    RADIO_ON_AMOUNT: `${ICON_BASE_URL}/common/create_flow/radio_on_amount.svg`,
    ABANDONED_WHITE: `${ICON_BASE_URL}/common/create_flow/abandoned_white.svg`,
    CONTACT_US_MAIL: `${ICON_BASE_URL}/common/create_flow/contact_us_mail.svg`,
    REFRESH_BALANCE: `${ICON_BASE_URL}/common/create_flow/refresh_balance.svg`,
    ADD_BUTTON_GREY: `${ICON_BASE_URL}/common/create_flow/add_button_grey.svg`,
    VIRTUAL_ACCOUNT: `${ICON_BASE_URL}/common/create_flow/virtual_account.svg`,
    GMAIL_RED_ERROR: `${ICON_BASE_URL}/common/create_flow/gmail_red_error.svg`,
    DATE_CIRCLE_BLUE: `${ICON_BASE_URL}/common/create_flow/date_circle_blue.svg`,
    AUTOFILL_BLUE_BG: `${ICON_BASE_URL}/common/create_flow/autofill_blue_bg.svg`,
    RADIO_OFF_AMOUNT: `${ICON_BASE_URL}/common/create_flow/radio_off_amount.svg`,
    ADD_BUTTON_ORANGE: `${ICON_BASE_URL}/common/create_flow/add_button_orange.svg`,
    CLOSE_WITH_SQUARE: `${ICON_BASE_URL}/common/create_flow/close_with_square.svg`,
    DETAIL_PAGE_LINEAR: `${ICON_BASE_URL}/common/create_flow/detail_page_linear.svg`,
    CREATE_NEW_ACCOUNT: `${ICON_BASE_URL}/common/create_flow/create_new_account.svg`,
    PROFILE_UNSELECTED: `${ICON_BASE_URL}/common/create_flow/profile_unselected.svg`,
    DELETE_WHITE_FILLED: `${ICON_BASE_URL}/common/create_flow/delete_white_filled.svg`,
    PASTE_WHITE_BLUE_BG: `${ICON_BASE_URL}/common/create_flow/paste_white_blue_bg.svg`,
    GMAIL_GREEN_VERIFIED: `${ICON_BASE_URL}/common/create_flow/email_green_verified.svg`,
    PASTE_WHITE_GREEN_BG: `${ICON_BASE_URL}/common/create_flow/paste_white_green_bg.svg`,
    REFRESH_ALL_BALANCES: `${ICON_BASE_URL}/common/create_flow/refresh_all_balances.svg`,
    CLOSE_WITH_GREY_CIRCLE: `${ICON_BASE_URL}/common/approval/close_with_grey_circle.svg`,
    CLOSE_WITH_BLUE_CIRCLE: `${ICON_BASE_URL}/common/view_all/close_with_blue_circle.svg`,
    REFRESH_WITH_BLUE_BOX: `${ICON_BASE_URL}/common/create_flow/refresh_with_blue_box.svg`,
    RADIO_BUTTON_SELECTED: `${ICON_BASE_URL}/common/create_flow/radio_button_selected.svg`,
    ERROR_WITH_RED_CRICLE: `${ICON_BASE_URL}/common/create_flow/error_with_red_cricle.svg`,
    REGISTER_ACCOUNT_WHITE: `${ICON_BASE_URL}/common/create_flow/register_account_white.svg`,
    CLOSE_WITH_BLUE_SQUARE: `${ICON_BASE_URL}/common/create_flow/close_with_blue_square.svg`,
    OCCURENCES_CIRCLE_BLUE: `${ICON_BASE_URL}/common/create_flow/occurences_circle_blue.svg`,
    EDIT_WHITE_WITH_BLUE_BG: `${ICON_BASE_URL}/common/create_flow/edit_white_with_blue_bg.svg`,
    GMAIL_WITH_WHITE_CIRCLE: `${ICON_BASE_URL}/common/create_flow/gmail_with_white_circle.svg`,
    CONTACT_WITH_WHITE_CIRCLE: `${ICON_BASE_URL}/common/create_flow/contact_with_white_circle.svg`,
    RADIO_BUTTON_NOT_SELECTED: `${ICON_BASE_URL}/common/create_flow/radio_button_not_selected.svg`,
    VIEW_CONSOLIDATED_STATEMENT: `${ICON_BASE_URL}/common/create_flow/view_consolidated_statement.svg`,
    VIEW_STATEMENT_WITH_BLUE_BOX: `${ICON_BASE_URL}/common/create_flow/view_statement_with_blue_box.svg`,
    VERIFIED_WITH_WHITE_CIRCLE_GREEN: `${ICON_BASE_URL}/common/create_flow/verified_with_white_circle_green.svg`,
    ERROR_WITH_WHITE_OUTLINED_CIRCLE: `${ICON_BASE_URL}/common/create_flow/error_with_white_outlined_circle.svg`,

    // VIEW_ALL
    LABEL: `${ICON_BASE_URL}/common/view_all/label.svg`,
    SHARE: `${ICON_BASE_URL}/common/view_all/share.svg`,
    FILTER: `${ICON_BASE_URL}/common/view_all/filter.svg`,
    DELETE: `${ICON_BASE_URL}/common/view_all/delete.svg`,
    UPLOAD: `${ICON_BASE_URL}/common/view_all/upload.svg`,
    SORT_BY: `${ICON_BASE_URL}/common/view_all/sort_by.svg`,
    CALENDER: `${ICON_BASE_URL}/common/view_all/calender.svg`,
    SPLIT_VIEW: `${ICON_BASE_URL}/common/view_all/split_view.svg`,
    SEARCH_WHITE: `${ICON_BASE_URL}/common/view_all/search_white.svg`,
    RED_CHECKMARK: `${ICON_BASE_URL}/common/view_all/red_check_mark.svg`,
    GRID_VIEW_WHITE: `${ICON_BASE_URL}/common/view_all/grid_view_white.svg`,
    LIST_VIEW_WHITE: `${ICON_BASE_URL}/common/view_all/list_view_white.svg`,
    GO_TO_DASHBOARD: `${ICON_BASE_URL}/common/view_all/go_to_dashboard.svg`,
    GREEN_CHECKMARK: `${ICON_BASE_URL}/common/view_all/green_checkmark.svg`,
    SPLIT_VIEW_COLOR: `${ICON_BASE_URL}/common/view_all/split_view_color.svg`,
    CHECK_MARK_WHITE: `${ICON_BASE_URL}/common/view_all/check_mark_white.svg`,
    DOWNLOAD_STATEMENT: `${ICON_BASE_URL}/common/view_all/download_statement.svg`,
    CUSTOMIZATION_WHITE: `${ICON_BASE_URL}/common/view_all/customization_white.svg`,
    RELOAD_REFRESH_WHITE: `${ICON_BASE_URL}/common/view_all/reload_refresh_white.svg`,
    CLOSE_WITH_BLUE_CRICLE: `${ICON_BASE_URL}/common/view_all/close_with_blue_cricle.svg`,
    ADDITIONAL_FIELDS_WHITE: `${ICON_BASE_URL}/common/view_all/additional_fields_white.svg`,
    ERROR_WITH_ORANGE_CIRCLE: `${ICON_BASE_URL}/common/view_all/error_with_orange_circle.svg`,
    ASSIGN_TAG_WITHOUT_CIRCLE: `${ICON_BASE_URL}/common/view_all/assign_tag_without_circle.svg`,
    GO_TO_APPROVAL_WHITE_CIRCLE: `${ICON_BASE_URL}/common/view_all/go_to_approval_white_circle.svg`,
    NOT_SELECTED_WITH_GREY_CIRCLE: `${ICON_BASE_URL}/common/view_all/not_selected_with_grey_circle.svg`,
    REIMBURSEMENT_ACCOUNT_WITH_WHITE_CIRCLE: `${ICON_BASE_URL}/common/view_all/reimbursement_accounts_with_white_circle.svg`,
    REIMBURSEMENT_TRANSACTION_WITH_WHITE_CIRCLE: `${ICON_BASE_URL}/common/view_all/reimbursement_transaction_with_white_circle.svg`,

    // DETAIL_PAGE
    INFO: `${ICON_BASE_URL}/common/detail_page/info.svg`,
    ARCHIVE: `${ICON_BASE_URL}/common/detail_page/archive.svg`,
    ADDRESS: `${ICON_BASE_URL}/common/detail_page/address.svg`,
    INTERNAL: `${ICON_BASE_URL}/common/detail_page/internal.svg`,
    FAVOURITE: `${ICON_BASE_URL}/common/detail_page/favourite.svg`,
    UNARCHIVE: `${ICON_BASE_URL}/common/detail_page/unarchive.svg`,
    LINK_WHITE: `${ICON_BASE_URL}/common/detail_page/link_white.svg`,
    ASSIGN_TAG: `${ICON_BASE_URL}/common/detail_page/assign_tag.svg`,
    ADDRESS_MAP: `${ICON_BASE_URL}/common/detail_page/address_map.svg`,
    SELECT_GREEN: `${ICON_BASE_URL}/common/detail_page/select_green.svg`,
    OUTLINE_CLOCK: `${ICON_BASE_URL}/common/detail_page/outline_clock.svg`,
    RECREATE_WHITE: `${ICON_BASE_URL}/common/detail_page/recreate_white.svg`,
    LIVE_STATEMENT: `${ICON_BASE_URL}/common/detail_page/live_statement.svg`,
    VIEW_STATEMENT: `${ICON_BASE_URL}/common/detail_page/view_statement.svg`,
    SWITCH_ACCOUNT: `${ICON_BASE_URL}/common/detail_page/switch_account.svg`,
    FAVOURITE_FILLED: `${ICON_BASE_URL}/common/detail_page/favourite_filled.svg`,
    LINKED_WHITE_CIRCLE: `${ICON_BASE_URL}/common/detail_page/linked_white_circle.svg`,
    TRANSACTION_HISTORY: `${ICON_BASE_URL}/common/detail_page/transaction_history.svg`,
    REIMBURSEMENT_DETAIL: `${ICON_BASE_URL}/common/detail_page/reimbursement_detail.svg`,
    LABEL_WITH_CIRCLE: `${ICON_BASE_URL}/common/detail_page/label_with_white_circle.svg`,
    EDIT_WITH_WHITE_CIRCLE: `${ICON_BASE_URL}/common/detail_page/edit_with_white_circle.svg`,
    VIEW_STATEMENT_OUTLINE: `${ICON_BASE_URL}/common/detail_page/view_statement_outlined.svg`,
    BENEFICIARY_WHITE_CIRCLE: `${ICON_BASE_URL}/common/detail_page/beneficiary_white_circle.svg`,
    DELETE_WITH_WHITE_CIRCLE: `${ICON_BASE_URL}/common/detail_page/delete_with_white_circle.svg`,
    CONFIDENTIAL_TRANSACTION: `${ICON_BASE_URL}/common/detail_page/confidential_transaction.svg`,
    DISCARD_WITH_WHITE_CIRCLE: `${ICON_BASE_URL}/common/detail_page/discard_with_white_circle.svg`,
    ASSSOCIATED_ACCOUNTS_FOUND: `${ICON_BASE_URL}/common/detail_page/associated_accounts_found.svg`,
    INTERNAL_WITH_WHITE_CIRCLE: `${ICON_BASE_URL}/common/detail_page/internal_with_white_circle.svg`,
    EDIT_USERS_WITH_WHITE_CIRCLE: `${ICON_BASE_URL}/common/detail_page/edit_users_with_white_circle.svg`,
    INITIATE_INTERNAL_TRANSACTION: `${ICON_BASE_URL}/common/detail_page/initiate_internal_transaction.svg`,
    REIMBURSEMENT_ACCOUNTS_LINEAR: `${ICON_BASE_URL}/common/detail_page/reimbursement_accounts_linear.svg`,
    REIMBURSEMENT_TRANSACTION_LINEAR: `${ICON_BASE_URL}/common/detail_page/reimbursement_transaction_linear.svg`,
    INTERNAL_WHITE_CIRCLE_WITHOUT_FILL: `${ICON_BASE_URL}/common/detail_page/internal_with_white_circle_without_fill.svg`,

    // APPROVAL
    QUEUED: `${ICON_BASE_URL}/common/approval/queued.svg`,
    PENDING: `${ICON_BASE_URL}/common/approval/pending.svg`,
    UNKNOWN: `${ICON_BASE_URL}/common/approval/unknown.svg`,
    REJECTED_RED: `${ICON_BASE_URL}/common/approval/rejected_red.svg`,
    RECREATE_RED: `${ICON_BASE_URL}/common/approval/recreate_red.svg`,
    PENDING_BLUE: `${ICON_BASE_URL}/common/approval/pending_blue.svg`,
    FAILED_LINEAR: `${ICON_BASE_URL}/common/approval/failed_linear.svg`,
    APPROVED_LINEAR: `${ICON_BASE_URL}/common/approval/approved_linear.svg`,
    APPROVAL_STATUS: `${ICON_BASE_URL}/common/dashboard/approval_status.svg`,
    APPROVE_MORE_TXN: `${ICON_BASE_URL}/common/approval/approve_more_transaction.svg`,
    APPROVED_GREEN_LINEAR: `${ICON_BASE_URL}/common/approval/approved_linear_green.svg`,
    AWAITING_VERIFICATION: `${ICON_BASE_URL}/common/approval/awaiting_verification.svg`,
    REJECT_ICON_RED_LINEAR: `${ICON_BASE_URL}/common/approval/reject_icon_red_linear.svg`,
    SELECTED_WITH_GREEN_CIRCLE: `${ICON_BASE_URL}/common/approval/selected_with_green_circle.svg`,
    APPROVE_CIRCLE_GREEN_CHECKMARK: `${ICON_BASE_URL}/common/approval/approve_circle_green_checkmark.svg`,
    CONFIDENTIAL_TRANSACTION_BLUE_BG: `${ICON_BASE_URL}/common/approval/confidential_transaction_blue_bg.svg`,
    REJECT_ICON_RED_WITH_WHITE_CIRCLE: `${ICON_BASE_URL}/common/approval/reject_icon_red_with_white_circle.svg`,
    SELECT_ALL_WITH_WHITE_FILLED_CIRCLE: `${ICON_BASE_URL}/common/approval/select_all_with_white_filled_circle.svg`,
    SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE: `${ICON_BASE_URL}/common/approval/select_all_with_white_outlined_circle.svg`,

    // DASHBOARD
    ADD: `${ICON_BASE_URL}/common/dashboard/add.svg`,
    ALERT: `${ICON_BASE_URL}/common/dashboard/alert.svg`,
    BIRTHDAY: `${ICON_BASE_URL}/common/dashboard/birthday.svg`,
    DASHBOARD: `${ICON_BASE_URL}/common/dashboard/dashboard.svg`,
    ALERT_WHITE: `${ICON_BASE_URL}/common/dashboard/alert_white.svg`,
    HOME_SELECTED: `${ICON_BASE_URL}/common/dashboard/home_selected.svg`,
    REMINDERS_WHITE: `${ICON_BASE_URL}/common/dashboard/reminders_white.svg`,
    HOME_UNSELECTED: `${ICON_BASE_URL}/common/dashboard/home_unselected.svg`,
    ACCOUNT_SELECTED: `${ICON_BASE_URL}/common/dashboard/account_selected.svg`,
    TRANSACTION_WHITE: `${ICON_BASE_URL}/common/dashboard/transaction_white.svg`,
    ANNOUNCEMENT_GREY: `${ICON_BASE_URL}/common/dashboard/announcement_grey.svg`,
    NOTIFICATION_GREY: `${ICON_BASE_URL}/common/dashboard/notifications_grey.svg`,
    // NOTIFICATION_GREY: `${ICON_BASE_URL}/common/dashboard/notification with indication.svg`,
    ACCOUNT_UNSELECTED: `${ICON_BASE_URL}/common/dashboard/account_unselected.svg`,
    TRANSACTION_SELECTED: `${ICON_BASE_URL}/common/dashboard/transaction_selected.svg`,
    TRANSACTION_UNSELECTED: `${ICON_BASE_URL}/common/dashboard/transaction_unselected.svg`,
    HOME_UNSELECTED_OUTLINE: `${ICON_BASE_URL}/common/dashboard/home_unselected_outline.svg`,
    CLOSE_WITH_WHITE_CIRCLE: `${ICON_BASE_URL}/common/dashboard/close_with_white_circle.svg`,
    MORE_FEATURES_SELECTED: `${ICON_BASE_URL}/common/dashboard/more_features_selected.svg`,
    MORE_FEATURES_UNSELECTED: `${ICON_BASE_URL}/common/dashboard/more_features.svg`,

    // TIMELINE
    iOS: `${ICON_BASE_URL}/common/timeline_icons/ios.svg`,
    APPLE: `${ICON_BASE_URL}/common/timeline_icons/ios.svg`,
    LINUX: `${ICON_BASE_URL}/common/timeline_icons/linux.svg`,
    GOOGLE: `${ICON_BASE_URL}/common/timeline_icons/google.svg`,
    MOBILE: `${ICON_BASE_URL}/common/timeline_icons/mobile.svg`,
    REMARK: `${ICON_BASE_URL}/common/timeline_icons/remark.svg`,
    SAFARI: `${ICON_BASE_URL}/common/timeline_icons/safari.svg`,
    CHROME: `${ICON_BASE_URL}/common/timeline_icons/chrome.svg`,
    MAC_OS: `${ICON_BASE_URL}/common/timeline_icons/mac_os.svg`,
    WINDOWS: `${ICON_BASE_URL}/common/timeline_icons/windows.svg`,
    ANDROID: `${ICON_BASE_URL}/common/timeline_icons/android.svg`,
    EXPLORE: `${ICON_BASE_URL}/common/timeline_icons/explorer.svg`,
    APPSTORE: `${ICON_BASE_URL}/common/timeline_icons/appstore.svg`,
    PLAYSTORE: `${ICON_BASE_URL}/common/timeline_icons/playstore.svg`,
    MICROSOFT: `${ICON_BASE_URL}/common/timeline_icons/microsoft.svg`,
    REJECTION: `${ICON_BASE_URL}/common/timeline_icons/rejection.svg`,
    UNKNOWN_OS: `${ICON_BASE_URL}/common/timeline_icons/unknown_os.svg`,
    APP_DETAILS: `${ICON_BASE_URL}/common/timeline_icons/app_details.svg`,
    WEB_DEFAULT: `${ICON_BASE_URL}/common/timeline_icons/web_default.svg`,
    DEFAULT: `${ICON_BASE_URL}/common/timeline_icons/default_platform.svg`,
    USER_DETAILS: `${ICON_BASE_URL}/common/timeline_icons/user_details.svg`,
    INTERNET_EXPLORER: `${ICON_BASE_URL}/common/timeline_icons/explorer.svg`,
    AUTHORIZATION: `${ICON_BASE_URL}/common/timeline_icons/authorization.svg`,
    MICROSOFT_EDGE: `${ICON_BASE_URL}/common/timeline_icons/microsoft_edge.svg`,
    DEVICE_DETAILS: `${ICON_BASE_URL}/common/timeline_icons/device_details.svg`,
    MOZILLA_FIREFOX: `${ICON_BASE_URL}/common/timeline_icons/mozilla_firefox.svg`,
    NETWORK_DETAILS: `${ICON_BASE_URL}/common/timeline_icons/network_details.svg`,
    DEFAULT_BROWSER: `${ICON_BASE_URL}/common/timeline_icons/default_browser.svg`,
    SESSION_DETAILS: `${ICON_BASE_URL}/common/timeline_icons/session_details.svg`,
    TIMELINESECTION: `${ICON_BASE_URL}/common/timeline_icons/timeline_section.svg`,
    ACTIVITY_DETAILS: `${ICON_BASE_URL}/common/timeline_icons/activity_details.svg`,

    // LOGIN
    UBI_KEY: `${ICON_BASE_URL}/common/login/ubi_key.svg`,
    PASSKEY: `${ICON_BASE_URL}/common/login/passkey.svg`,
    PASSWORD: `${ICON_BASE_URL}/common/login/password.svg`,
    PASSWORD_SHOW: `${ICON_BASE_URL}/common/login/password_show.svg`,
    PASSWORD_HIDE: `${ICON_BASE_URL}/common/login/password_hide.svg`,
    MOBILE_DEVICE: `${ICON_BASE_URL}/common/login/mobile_device.svg`,
    LAPTOP_PC_DEVICE: `${ICON_BASE_URL}/common/login/laptop_pc_device.svg`,

    // HOMEDASHBOARD
    PAY_WITH_BLUE_CIRCLE: `${ICON_BASE_URL}/common/home_dashboard_icons/pay_with_blue_circle.svg`,
    APPROVE_WITH_BLUE_CIRCLE: `${ICON_BASE_URL}/common/home_dashboard_icons/approve_with_blue_circle.svg`,
    RECIEVE_WITH_BLUE_CIRCLE: `${ICON_BASE_URL}/common/home_dashboard_icons/recieve_with_blue_circle.svg`,
    PAYABLES_ACCOUNT_BLUE_CIRCLE: `${ICON_BASE_URL}/common/home_dashboard_icons/payables_with_blue_circle.svg`,
    CREATE_ACCOUNT_WITH_CIRCLE: `${ICON_BASE_URL}/common/home_dashboard_icons/create_account_with_blue_circle.svg`,
    TAX_ACCOUNTS_WITH_BLUE_CIRCLE: `${ICON_BASE_URL}/common/home_dashboard_icons/tax_accounts_with_blue_circle.svg`,
    RECIEVABLES_ACCOUNT_BLUE_CIRCLE: `${ICON_BASE_URL}/common/home_dashboard_icons/receivables_with_blue_circle.svg`,
    OWNER_ACCOUNT_WITH_BLUE_CIRCLE: `${ICON_BASE_URL}/common/home_dashboard_icons/owner_accounts_with_blue_circle.svg`,
    REIMBURSEMENT_TRANSACTION_BLUE_CIRCLE: `${ICON_BASE_URL}/common/home_dashboard_icons/reimbursement_transaction.svg`,
    TAX_TRANSACTION_WITH_BLUE_CIRCLE: `${ICON_BASE_URL}/common/home_dashboard_icons/tax_transactions_with_blue_circle.svg`,
    INTERNAL_ACCOUNT_WITH_BLUE_CIRCLE: `${ICON_BASE_URL}/common/home_dashboard_icons/internal_account_with_blue_circle.svg`,
    PRIVATE_TRANSACTION_BLUE_CIRCLE: `${ICON_BASE_URL}/common/home_dashboard_icons/private_transaction_with_blue_circle.svg`,
    REMITTER_ACCOUNT_WITH_BLUE_CIRCLE: `${ICON_BASE_URL}/common/home_dashboard_icons/remitter_accounts_with_blue_circle.svg`,
    INTERNAL_TRANSACTION_BLUE_CIRCLE: `${ICON_BASE_URL}/common/home_dashboard_icons/internal_transaction_with_blue_circle.svg`,
    BENEFICIARY_ACCOUNT_WITH_BLUE_CIRCLE: `${ICON_BASE_URL}/common/home_dashboard_icons/beneficiary_account_with_blue_circle.svg`,
    FIELD_FORCE_ACCOUNTS_WITH_BLUE_CIRCLE: `${ICON_BASE_URL}/common/home_dashboard_icons/field_force_accounts_with_blue_circle.svg`,
    BENEFICIARY_TRANSACTION_BLUE_CIRCLE: `${ICON_BASE_URL}/common/home_dashboard_icons/beneficiary_transaction_with_blue_circle.svg`,
    FIELD_FORCE_TRANSACTION_BLUE_CIRCLE: `${ICON_BASE_URL}/common/home_dashboard_icons/field_force_transactions_with_blue_circle.svg`,
    REIMBURSEMENT_ACCOUNTS_WITH_BLUE_CIRCLE: `${ICON_BASE_URL}/common/home_dashboard_icons/reimbursement_accounts_with_blue_circle.svg`,

    // GRAPHICS NO_DATA
    NO_DATA_FOUND: `${ICON_BASE_URL}/graphics/no_data/no_data_found.svg`,
    FEATURE_NOT_ASSIGNED: `${ICON_BASE_URL}/graphics/no_data/feature_not_assigned.svg`,
    NO_PENDING_TRANSACTION: `${ICON_BASE_URL}/graphics/no_data/no_pending_transaction.svg`,
    NO_STATISTICS_AVAILABLE: `${ICON_BASE_URL}/graphics/no_data/no_statistics_available.svg`,

    // GRAPHICS ERROR
    ERROR: `${ICON_BASE_URL}/graphics/error/error.svg`,
    CONTACT_US: `${ICON_BASE_URL}/graphics/error/contact_us.svg`,
    PAGE_NOT_FOUND: `${ICON_BASE_URL}/graphics/error/404_error.svg`,
    UNKNOWN_ERROR: `${ICON_BASE_URL}/graphics/error/unknown_error.svg`,
    UNABLE_TO_RETRIVE_IP: `${ICON_BASE_URL}/graphics/error/unable_to_retrive_ip_address.svg`,

    // GRAPHICS LOGIN
    LOGIN: `${ICON_BASE_URL}/graphics/login/login.svg`,
    CHANGE_PASSWORD_GRAPHICS: `${ICON_BASE_URL}/graphics/login/change_password.svg`,
    SET_NEW_PASSWORD: `${ICON_BASE_URL}/graphics/login/set_new_password.svg`,
    BG_FOR_LOGIN: `${ICON_BASE_URL}/graphics/login/backgrond_for_login.svg`,
    CONTACT_ADMIN: `${ICON_BASE_URL}/graphics/login/contact_admin.svg`,

    // GRAPHICS TOTP
    SCAN_GRAPHICS: `${ICON_BASE_URL}/graphics/totp/scan.svg`,
    ENTER_CODE: `${ICON_BASE_URL}/graphics/totp/enter_code.svg`,
    BACKUP_CODES: `${ICON_BASE_URL}/graphics/totp/backup_codes.svg`,
    TOTP_ENABLED: `${ICON_BASE_URL}/graphics/totp/totp_enabled.svg`,
    DOWNLOAD_GRAPHICS: `${ICON_BASE_URL}/graphics/totp/download.svg`,

    // GRAPHICS BYOK
    SET_BYOK: `${ICON_BASE_URL}/graphics/byok/set_byok.svg`,
    BYOK_FAILED: `${ICON_BASE_URL}/graphics/byok/failed.svg`,
    ACTIVE_GRAPHICS: `${ICON_BASE_URL}/graphics/byok/active.svg`,
    ENCRYPT_DATA: `${ICON_BASE_URL}/graphics/byok/encrypt_data.svg`,
    ACCESS_PORTAL: `${ICON_BASE_URL}/graphics/byok/access_portal.svg`,
    GET_CREDENTIALS: `${ICON_BASE_URL}/graphics/byok/get_credentials.svg`,
    ENCRYPTION_IN_PROGRESS: `${ICON_BASE_URL}/graphics/byok/encryption_in_process.svg`,

    // GRAPHICS GENERAL
    ASSIGN: `${ICON_BASE_URL}/graphics/general/assign.svg`,
    SECURITY: `${ICON_BASE_URL}/graphics/general/security.svg`,
    UNASSIGN: `${ICON_BASE_URL}/graphics/general/unassign.svg`,
    SETTINGS_GRAPHICS: `${ICON_BASE_URL}/graphics/general/setting.svg`,
    REMINDER_GRAPHICS: `${ICON_BASE_URL}/graphics/general/reminder.svg`,
    VIEW_CATEGORY_GRAPHICS: `${ICON_BASE_URL}/graphics/general/view_category.svg`,
    IFSC_VERIFICATION_GRAPHICS: `${ICON_BASE_URL}/graphics/general/ifsc_verification.svg`,
    
    // MODULES
    MODULES_GRAPHICS: `${ICON_BASE_URL}/graphics/landing_page/modules.svg`,

    // GIF
    LOADER_GIF: `${ICON_BASE_URL}/gifs/inputloader_white.gif`,
    LOADER_BLUE: `${ICON_BASE_URL}/gifs/inputloader_blue.gif`,
    ARROW_UP_GREEN_GIF: `${ICON_BASE_URL}/gifs/arrow_up_green_gif.gif`,
    ARROW_DOWN_RED_GIF : `${ICON_BASE_URL}/gifs/arrow_down_red_gif.gif`,

    // EMAIL
    OTP: `${ICON_BASE_URL}/email/otp.svg`,
    MIS_WHITE: `${ICON_BASE_URL}/email/mis_white.svg`,
    PAYMENT_ADVICE: `${ICON_BASE_URL}/email/payment_advice.svg`,
    PAY_WITH_CIRCLE: `${ICON_BASE_URL}/email/pay_with_circle.svg`,
    NEW_DEVICE_iPHONE: `${ICON_BASE_URL}/email/new_device_iphone.svg`,
    NEW_DEVICE_MACBOOK: `${ICON_BASE_URL}/email/new_device_macbook.svg`,
    NEW_DEVICE_ANDROID: `${ICON_BASE_URL}/email/new_device_android.svg`,
    NEW_DEVICE_WINDOWS: `${ICON_BASE_URL}/email/new_device_windows.svg`,
    VERIFY_EMAIL_ADDRESS: `${ICON_BASE_URL}/email/verify_email_address.svg`,
    ADDITIONAL_RECIPIENTS: `${ICON_BASE_URL}/email/additional_recipient.svg`,
    SEND_TRANSACTION_INITIATION_EMAILS_WITH_WHITE_CIRCLE: `${ICON_BASE_URL}/email/send_transaction_initiation_emails_with_white_circle.svg`,
    

    // LOGO
    XPENTRA_BLUE: `${ICON_BASE_URL}/xpentra_logo/xpentra_blue.svg`,
    XPENTRA_WHITE: `${ICON_BASE_URL}/xpentra_logo/xpentra_white.svg`,
    XPENTRA_SYMBOL_WHITE: `${ICON_BASE_URL}/xpentra_logo/xpentra_symbol_white.svg`,

    // CATEGORY
    VENDOR: `${ICON_BASE_URL}/web/vendor.svg`,
    SALARY: `${ICON_BASE_URL}/web/salary.svg`,
    RENTAL: `${ICON_BASE_URL}/web/rental.svg`,
    CLIENT: `${ICON_BASE_URL}/web/client.svg`,
    MERCHANT: `${ICON_BASE_URL}/web/merchant.svg`,
    BENEFICIARY: `${ICON_BASE_URL}/web/beneficiary.svg`,
    FIELD_FORCE: `${ICON_BASE_URL}/web/field_force.svg`,
    SUBSCRIPTION: `${ICON_BASE_URL}/web/subscription.svg`,
    CARD: `${ICON_BASE_URL}/common/category_icon/card.svg`,
    OWNER_ACCOUNT: `${ICON_BASE_URL}/web/owner_account.svg`,
    INCOME_TRANSACTION: `${ICON_BASE_URL}/web/income_transaction.svg`,
    DEFAULT_CATEGORY: `${ICON_BASE_URL}/web/beneficiary_category_default.svg`,
    // TAX CATEGORY
    TDS: `${ICON_BASE_URL}/web/tds.svg`,
    GST: `${ICON_BASE_URL}/web/gst.svg`,
    INCOME_TAX: `${ICON_BASE_URL}/web/income_tax.svg`,
    PROFESSIONAL_TAX: `${ICON_BASE_URL}/web/professional_tax.svg`,

    // STORE
    APP_STORE_LINK: `${ICON_BASE_URL}/common/store/appstore_link.svg`,
    PLAYSTORE_LINK: `${ICON_BASE_URL}/common/store/playstore_link.svg`,

    // OTHERS
    REDIRECT: `${ICON_BASE_URL}/common/others/redirect.svg`,
    PROFILE_SELECTED: `${ICON_BASE_URL}/common/others/profile_selected.svg`,
    ERROR_WITH_YELLOW_CIRCLE: `${ICON_BASE_URL}/common/others/error_with_yellow_circle.svg`,
    SERVICE_NOT_FOUND_GRADIENT: `${ICON_BASE_URL}/common/others/service_not_found_gradient.svg`,

    PASSWORD_HIDDEN_DARKGREY: `${ICON_BASE_URL}/similar/password_hidden_darkgrey.svg`,
    PASSWORD_VISIBLE_DARKGREY: `${ICON_BASE_URL}/similar/password_visible_darkgrey.svg`,

    // modules
    WISE: `${ICON_BASE_URL}/common/modules/wise.svg`,
    EXPAND: `${ICON_BASE_URL}/common/modules/expand.svg`,
    REVISE: `${ICON_BASE_URL}/common/modules/revise.svg`,
    REALISE:`${ICON_BASE_URL}/common/modules/realise.svg`,
    APPRISE: `${ICON_BASE_URL}/common/modules/apprise.svg`,
    ANALYSE: `${ICON_BASE_URL}/common/modules/analyse.svg`,
    PRECISE: `${ICON_BASE_URL}/common/modules/precise.svg`,
    UTILISE: `${ICON_BASE_URL}/common/modules/utilise.svg`,
    ITEMISE: `${ICON_BASE_URL}/common/modules/itemise.svg`,
    TAXWISE: `${ICON_BASE_URL}/common/modules/taxwise.svg`,
    MONETISE:`${ICON_BASE_URL}/common/modules/monetise.svg`,
    GATEWISE:`${ICON_BASE_URL}/common/modules/gatewise.svg`,
    OPTIMISE:`${ICON_BASE_URL}/common/modules/optimise.svg`,
    CARDWISE:`${ICON_BASE_URL}/common/modules/cardwise.svg`,
    COLLAPSE: `${ICON_BASE_URL}/common/modules/collapse.svg`,
    AUTOMISE: `${ICON_BASE_URL}/common/modules/automise.svg`,
    DIGITISE: `${ICON_BASE_URL}/common/modules/digitise.svg`,
    MEMORISE: `${ICON_BASE_URL}/common/modules/memorise.svg`,
    SUMMERISE:`${ICON_BASE_URL}/common/modules/summarise.svg`,
    RECOGNISE: `${ICON_BASE_URL}/common/modules/recognise.svg`,
    VISUALISE: `${ICON_BASE_URL}/common/modules/visualise.svg`,
    SUPERWISE: `${ICON_BASE_URL}/common/modules/superwise.svg`,
    STREETWISE:`${ICON_BASE_URL}/common/modules/streetwise.svg`,
    CAPITALISE: `${ICON_BASE_URL}/common/modules/capitalise.svg`,
    CATEGORISE: `${ICON_BASE_URL}/common/modules/categorise.svg`,
    MATERIALISE: `${ICON_BASE_URL}/common/modules/materialise.svg`,
    EXPENSEWISE: `${ICON_BASE_URL}/common/modules/expensewise.svg`,
    MODULE_DEFAULT: `${ICON_BASE_URL}/common/modules/module_default.svg`,
    MODULE_FLOAT_BUTTON: `${ICON_BASE_URL}/common/modules/module_float_button.svg`,

    // countries
    INDIA: `${ICON_BASE_URL}/common/countries/india.svg`,

    // landing page 
    VISION: `${ICON_BASE_URL}/landing_page/vision.svg`,
    VALUES: `${ICON_BASE_URL}/landing_page/values.svg`,
    MISSION: `${ICON_BASE_URL}/landing_page/mission.svg`,
    CONNECTOR_RIGHT: `${ICON_BASE_URL}/landing_page/connector_right.svg`,
    CONNECTOR_LEFT: `${ICON_BASE_URL}/landing_page/connector_left.svg`,
    ERP_SYSTEM: `${ICON_BASE_URL}/landing_page/erp_system.svg`,
    FLEXIBILITY: `${ICON_BASE_URL}/landing_page/flexibility.svg`,
    SCALABILITY: `${ICON_BASE_URL}/landing_page/scalability_issues_with_card.svg`,
    TRANSPARENCY: `${ICON_BASE_URL}/landing_page/transparency.svg`,
    AUTOMATION_ICON: `${ICON_BASE_URL}/landing_page/automation.svg`,
    CONSOLIDATION: `${ICON_BASE_URL}/landing_page/consolidation.svg`,
    SECURITY_HOME: `${ICON_BASE_URL}/landing_page/security_home.svg`,
    BHARAT_CONNECT: `${ICON_BASE_URL}/landing_page/bharat_connect.svg`,
    SLIDE_UP_ARROW: `${ICON_BASE_URL}/landing_page/slide_up_arrow.svg`,
    XPENTRA_FOR_AMCS: `${ICON_BASE_URL}/landing_page/xpentra_for_amcs.svg`,
    IDENTIFYING_GAPS: `${ICON_BASE_URL}/landing_page/identifying_gaps.svg`,
    VISION_DARK_BLUE: `${ICON_BASE_URL}/landing_page/vision_dark_blue.svg`,
    CUSTOM_NARRATION: `${ICON_BASE_URL}/landing_page/custom_narration.svg`,
    BIRTH_OF_XPENTRA: `${ICON_BASE_URL}/landing_page/birth_of_xpentra.svg`,
    NACH_COLLECTIONS: `${ICON_BASE_URL}/landing_page/nach_collections.svg`,
    SECURE_MANAGEMENT: `${ICON_BASE_URL}/landing_page/secure_management.svg`,
    UNIFIED_DASHBOARD: `${ICON_BASE_URL}/landing_page/unified_dashboard.svg`,
    ADVANCED_ANALYTICS: `${ICON_BASE_URL}/landing_page/advanced_analytics.svg`,
    CENTRALISED_ACCESS: `${ICON_BASE_URL}/landing_page/centralised_access.svg`,
    CYBERSECURITY_RISKS: `${ICON_BASE_URL}/landing_page/cybersecurity_risks_with_card.svg`,
    BETTER_DATA_CONTROL: `${ICON_BASE_URL}/landing_page/better_data_control.svg`,
    INCREASED_EFFICIENCY: `${ICON_BASE_URL}/landing_page/increased_efficiency.svg`,
    CUMULATIVE_STATEMENTS: `${ICON_BASE_URL}/landing_page/cumulative_statements.svg`,
    SPECIALISED_SOLUTIONS: `${ICON_BASE_URL}/landing_page/specialised_solutions.svg`,
    IMPROVED_CUSTOMISATION: `${ICON_BASE_URL}/landing_page/improved_customisation.svg`,
    XPENTRA_FOR_CORPORATES: `${ICON_BASE_URL}/landing_page/xpentra_for_corporates.svg`,
    REDUCED_RISK_OF_ERRORS: `${ICON_BASE_URL}/landing_page/reduced_risk_of_errors.svg`,
    ENHANCING_CONNECTIVITY: `${ICON_BASE_URL}/landing_page/enhancing_connectivity.svg`,
    RELIABLE_VERIFICATIONS: `${ICON_BASE_URL}/landing_page/reliable_verifications.svg`,
    EXPANDING_FUNCTIONALITY: `${ICON_BASE_URL}/landing_page/expanding_functionality.svg`,
    OPTIMISING_FOR_BUSINESS: `${ICON_BASE_URL}/landing_page/optimising_for_business.svg`,
    MOBILE_APP_FUNCTIONALITY: `${ICON_BASE_URL}/landing_page/mobile_app_functionality.svg`,
    ENHANCED_DECISION_MAKING: `${ICON_BASE_URL}/landing_page/enhanced_decision_making.svg`,
    TIME_AND_RESOURCE_SAVING: `${ICON_BASE_URL}/landing_page/time_and_resource_saving.svg`,
    RECONCILIATION_CHALLENGES: `${ICON_BASE_URL}/landing_page/reconciliation_challenges_with_card.svg`,
    DATA_MANAGEMENT_COMPLEXITY: `${ICON_BASE_URL}/landing_page/data_management_complexity_with_card.svg`,
    INTEGRATION_WITH_ALL_BANKS: `${ICON_BASE_URL}/landing_page/integration_with_all_banks.svg`,
    ENHANCED_FINANCIAL_CLARITY: `${ICON_BASE_URL}/landing_page/enhanced_financial_clarity.svg`,
    ADVANCED_SECURITY_PROTOCOLS: `${ICON_BASE_URL}/landing_page/advanced_security_protocols.svg`,
    UNIFIED_FINANCIAL_MANAGEMENT: `${ICON_BASE_URL}/landing_page/unified_financial_management.svg`,
    AUTOMATED_STATEMENT_RETRIEVAL: `${ICON_BASE_URL}/landing_page/automated_statement_retrieval.svg`,
    AUTHORIZATION_MATRIX_DARK_BLUE: `${ICON_BASE_URL}/landing_page/authorization_matrix_dark_blue.svg`,
    AUTHORIZATION_MATRIX_LIGHT_BLUE: `${ICON_BASE_URL}/landing_page/authorization_matrix_light_blue.svg`,
    EMPOWERING_FINANCIAL_OPERATIONS: `${ICON_BASE_URL}/landing_page/empowering_financial_operations.svg`,
    INSTANT_ACCESS_TO_ALL_ACCOUNT: `${ICON_BASE_URL}/landing_page/instant_access_to_all_account_balances.svg`,
    PERSONALISED_BANK_ACCOUNT_STATEMENT: `${ICON_BASE_URL}/landing_page/personalised_bank_account_statements.svg`,
    REAL_TIME_VENDOR_VERIFICATION: `${ICON_BASE_URL}/landing_page/real_time_vendor_verification_beneficiary_setup.svg`,
    INSTANT_ACCESS_TO_ALL_ACCOUNT_BALANCES: `${ICON_BASE_URL}/landing_page/instant_access_to_all_account_balances.svg`,
    EMPOWERING_FINANCIAL_OPERATIONS_BLUE: `${ICON_BASE_URL}/landing_page/empowering_financial_operations_with_blue_highlight.svg`,
    FINANCIAL_MANAGEMENT: `${ICON_BASE_URL}/landing_page/identifying_gaps.svg`,
    HAMBURGER_MOBILE: `${ICON_BASE_URL}/landing_page/hamburger.svg`,
    // file format
    DEFAULT_FILE: `${ICON_BASE_URL}/common/file_format/default.svg`,
    DEFAULT_IMAGE: `${ICON_BASE_URL}/common/file_format/default_image.svg`,


    //Remitter Account

    MATCH: `${ICON_BASE_URL}/common/detail_page/match_linear.svg`,
    UNMATCH: `${ICON_BASE_URL}/common/detail_page/unmatch_linear.svg`,
    MATCHED_WITH_CIRCLE: ` ${ICON_BASE_URL}/common/detail_page/match_with_white_circle.svg`,
    UNMATCHED_WITH_CIRCLE: ` ${ICON_BASE_URL}/common/detail_page/unmatch_with_white_circle.svg`,

    // brand logo 
    SUGEE: `${ICON_BASE_URL}/brand_logos/sugee.jpg`,
    NUVAMA: `${ICON_BASE_URL}/brand_logos/nuvama.jpg`,
    TYAANI: `${ICON_BASE_URL}/brand_logos/tyaani.jpg`,
    AJMERA: `${ICON_BASE_URL}/brand_logos/ajmera.jpg`,
    CP_GOENKA: `${ICON_BASE_URL}/brand_logos/cp_goenka.jpg`,
    WHITEGOLD: `${ICON_BASE_URL}/brand_logos/whitegold.jpg`,
    RITIKA_WOOD: `${ICON_BASE_URL}/brand_logos/ritika_wood.jpg`,
    RAHAB_HOUSING: `${ICON_BASE_URL}/brand_logos/rahab_housing.jpg`,
    LIVING_LIQUIDZ: `${ICON_BASE_URL}/brand_logos/living_liquidz.jpg`,
    LIC_MUTUAL_FUND: `${ICON_BASE_URL}/brand_logos/lic_mutual_fund.jpg`,
    GOLDSTANDARD_WEALTH: `${ICON_BASE_URL}/brand_logos/goldstandard_wealth.jpg`,
    CONFLUENTIA_ADVISORS: `${ICON_BASE_URL}/brand_logos/confluentia_advisors.jpg`,
    
};

export default ICONS;